<template>
  <NuxtLink to="/" class="block mx-auto mb-8 w-fit">
    <img src="/logo.png" alt="QuickMeazure Logo" class="h-24 w-auto" />
  </NuxtLink>
</template>

<script setup lang="ts">
// No logic needed
</script>

<style scoped>
/* Add custom styles if needed */
</style>
